import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { Card, CardContent } from "../ui/card";

export interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  icon?: ReactNode;
  tone?: "default" | "success" | "warning" | "danger";
  className?: string;
}

const toneClasses: Record<NonNullable<MetricCardProps["tone"]>, string> = {
  default: "text-foreground",
  success: "text-success",
  warning: "text-warning-foreground",
  danger: "text-danger",
};

export const MetricCard = ({ label, value, hint, icon, tone = "default", className }: MetricCardProps) => (
  <Card className={className}>
    <CardContent className="flex items-start justify-between gap-3 p-5">
      <div className="space-y-1">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        <p className={cn("text-2xl font-semibold tabular-nums", toneClasses[tone])}>{value}</p>
        {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      </div>
      {icon ? <div className="rounded-lg bg-muted p-2 text-muted-foreground">{icon}</div> : null}
    </CardContent>
  </Card>
);
